import React, {useEffect, useState} from "react";
import {mrbgStore} from './mrbgRedux/index.js';
import {formsJson} from '../../mrbgLib/formsJson.js';
import mrbgS2S from '../../mrbgLib/mrbgS2S.js';
import MrbgFormsCreator from './MrbgFormsCreator.jsx';
import MrbgCropImg from './MrbgCropImg.jsx';
import MrbgSpecialSection from './MrbgSpecialSection.jsx';
import MrbgTimeLine from './MrbgTimeLine.jsx';
import {MrbgAbsolutePieChart} from './MrbgPieChart.jsx';
import MrbgFullChart from './MrbgFullChart.jsx';

function MrbgFormsList({hideMenu,formsJsKey,readySettings,formStyle}){

  const
    [activeForms,setActiveForms] = useState(mrbgStore.getState().activeForms),
    formsList = {...mrbgStore.getState().mrbgVars.formsList};

  useEffect(()=>{
    activeForms.map(frameID=>{
      if( Object.keys(mrbgStore.getState().dynamicChartKey).length===0 && (frameID.endsWith('__FCFrame') || frameID.endsWith('__PCFrame')) )
        mrbgS2S( null, null, 'charts', 'load' ).then(y=>console.log(y))
    })
  },[activeForms])
  useEffect(()=>{
    const unsubscribe = mrbgStore.subscribe(()=>{
      setActiveForms ( mrbgStore.getState().activeForms )
    });
    return () =>unsubscribe();
  },[]);

  return(
    <ul id={formStyle.formsList} data-id="formsList" className={hideMenu? formStyle.wideFormsList:''}>
      {
        Object.keys(formsList).map((k,i)=>{
          var
            formID  = formsList[k],
            frameID = formID+'Frame',
            roll    = formID.substring(formID.length-4),
            origin  = readySettings? readySettings[formID]: undefined,
            component;

          if( !origin )
            return '';

          if( !activeForms.includes(frameID) )
            return <li id={frameID} key={i}></li>

          if( !['__FC','__PC','__TL','__SS'].includes(roll) ){
            const
              originInfo = formsJson[formsJsKey][origin],
              formInfo   = originInfo.forms[formID]?? originInfo.tables[formID];
            if( !formInfo?.prepared ){
              var inputName,inputIndex,colName,preparedInputs;
              if( formInfo.inputs ){
                preparedInputs = {};
                Object.keys( formInfo.inputs ).forEach( inputKey => {
                  if( /__\d+$/.test(inputKey) ){
                    [colName,inputIndex] = inputKey.split( '__' );
                    inputName = `${colName}[${inputIndex}]`;
                  }
                  else inputName = colName = inputKey;
                  preparedInputs[inputName] = { ...originInfo.columns[colName], name:inputName, ...formInfo.inputs[inputKey] }
                })
                formInfo.inputs = preparedInputs;
              }
              if( formInfo.parts ){
                Object.keys(formInfo.parts).forEach(partName=>{
                  preparedInputs = {};
                  Object.keys(formInfo.parts[partName].inputs).forEach(inputKey=>{
                    if( /__\d+$/.test(inputKey) ){
                      [colName,inputIndex] = inputKey.split('__');
                      inputName = `${colName}[${inputIndex}]`;
                    }
                    else
                      inputName = colName = inputKey;
                    preparedInputs[inputName] = {...originInfo.columns[colName], name:inputName, ...formInfo.parts[partName].inputs[inputKey]}
                  })
                  formInfo.parts[partName].inputs = preparedInputs;
                })
              }
              if( formInfo.filters ){
                preparedInputs = {};
                Object.keys(formInfo.filters).forEach( inputKey => {
                  if( /__\d+$/.test(inputKey) ){
                    [colName,inputIndex] = inputKey.split( '__' );
                    inputName = `${colName}[${inputIndex}]`;
                  }
                  else
                    inputName = colName = inputKey;

                  var inputArr = {
                    ...originInfo.columns[colName],
                    name:inputName,
                    ...formInfo.filters[inputName]
                  };
                  if( ['mrbgNumberInput','mrbgPersianDate','mrbgPersianDateTime'].includes(inputArr.type) )
                    inputArr = [
                      {...inputArr,name:`${inputName}[0]`},
                      {...inputArr,name:`${inputName}[1]`}
                    ];
                  preparedInputs[inputName] = inputArr
                })
                formInfo.filters = preparedInputs;
              }
              if( formInfo.columns ){
                var com = formInfo.component || {};
                Object.keys(formInfo.columns).map(colName=>{
                  if( !Object.hasOwn(com,colName) ){
                    if( !formInfo.columns[colName] )
                      formInfo.columns[colName] = originInfo.columns[colName]?.label;

                    if( originInfo.columns[colName]?.type==='mrbgNumberInput' )
                      com[colName] = 'price';
                    else if( originInfo.columns[colName]?.type==='mrbgPersianDateTime' )
                      com[colName] = 'dateTime';
                    else if( originInfo.columns[colName]?.type==='mrbgPersianDate' )
                      com[colName] = 'date';
                    else if( originInfo.columns[colName]?.type==='mrbgCheckBox' )
                      com[colName] = 'icon';
                    else if( originInfo.columns[colName]?.type==='mrbgImgFile' )
                      com[colName] = 'img';
                  }
                })
                formInfo.component = com;
              }
              formInfo.prepared = true;
            }
            component = <MrbgFormsCreator {...{formID,origin,...formInfo,formStyle}} key={i}/>
          }
          else
            switch( roll ){
              case '__FC':
                component = Object.keys(formsJson[formsJsKey][formID]).map(k2=>{return <MrbgFullChart {...{...formsJson[formsJsKey][formID][k2]}} key={k2}/>});
                break;
              case '__PC':
                component =
                  <>
                    <MrbgFormsCreator {...{formID,...formsJson[formsJsKey].apoFilterPC,formStyle}} key={i}/>
                    <div>{Object.keys(formsJson[formsJsKey][formID]).map(k2=>{return <MrbgAbsolutePieChart {...{...formsJson[formsJsKey][formID][k2]}} key={k2}/>})}</div>
                  </>
                break;
              case '__TL':
                component = <MrbgTimeLine {...{...formsJson[formsJsKey][formID]}} />;
                break;
              case '__SS':
                component = <MrbgSpecialSection {...{...formsJson[formsJsKey][formID]}} />;
                break;
            };

          return <li id={frameID} className={(activeForms.includes(frameID))? '':formStyle.disable} key={i}>{component}</li>
        })
      }
      <MrbgCropImg />
    </ul>
  )
}
export default MrbgFormsList;